<div class="confirm">
	<div class="confirm-body">
		<header>
			<h3>Avís</h3>
			<button type="button" class="confirm_close" (click)="confirmService.closeById(id)">
				<i class="fas fa-times"></i>
			</button>
		</header>
		<hr>
		<p>{{text}}</p>
		<div class="row">
			<button type="button" (click)="confirmService.accept(id)">Acceptar</button>
			<button type="button" (click)="confirmService.cancel(id)">Cancel·lar</button>
		</div>
	</div>
</div>
<div class="confirm-background"></div>